export default "__VITE_ASSET__Bmiuj_85__"